import { render, staticRenderFns } from "./AggregatedPartnersComponent.vue?vue&type=template&id=13655f8b&scoped=true&"
import script from "./AggregatedPartnersComponent.vue?vue&type=script&lang=js&"
export * from "./AggregatedPartnersComponent.vue?vue&type=script&lang=js&"
import style0 from "./AggregatedPartnersComponent.vue?vue&type=style&index=0&id=13655f8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13655f8b",
  null
  
)

export default component.exports